import {textField} from 'material-components-web';

export default function () {
    const elements = document.querySelectorAll('.mdc-text-field');
    elements.forEach(element => new textField.MDCTextField(element));
}
